import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    position: 'relative',
    flex: '1',
    display: 'flex',
    flexDirection: 'column',
    borderRadius: '4px',
    padding: '24px 16px',
    background: '#F5F6F8'
  },

  bottomSpacing: {
    marginBottom: '16px'
  },

  avatarHolder: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: '16px',

    '& .avatar': {
      width: '64px',
      height: '64px'
    }
  },

  button: {
    position: 'absolute',
    top: '24px',
    right: '24px',
    width: '76px',
    height: '24px',
    background: '#FFFFFF',
    border: '1px solid #B64FCD',
    borderRadius: '4px',
    fontSize: theme.size.sm,
    color: '#B64FCD',

    '&:hover': {
      backgroundColor: 'lightgray'
    }
  },

  detailTitle: {
    marginBottom: '16px',
    fontSize: theme.size.sm,
    color: '#1F1F1F'
  },

  detailRow: {
    display: 'flex',
    alignItems: 'center',

    '&:not(:last-child)': {
      marginBottom: '16px'
    }
  },

  detailIcon: {
    marginRight: '8px',
    color: '#8F8F8F'
  },

  detailName: {
    marginRight: '4px',
    width: '56px',
    maxWidth: '56px',
    fontSize: theme.size.base,
    color: '#8F8F8F'
  },

  detailFlag: {
    marginRight: '8px'
  },

  detailValue: {
    width: '220px',
    maxWidth: '220px',
    fontSize: theme.size.base,
    color: '#1F1F1F'
  },

  showMore: {
    display: 'flex',
    alignItems: 'center',
    fontSize: theme.size.sm,
    color: '#8F8F8F',
    cursor: 'pointer',
    userSelect: 'none',

    '& .icon': {
      marginLeft: '4px'
    }
  },

  conversations: {
    display: 'flex',
    flexDirection: 'column'
  }
}))

export default useStyles
